import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { useGetThemeDataQuery } from "../../Services/vehicle/Vehicle";
import {
  GARAGE_ID,
  GARAGE_ROLE,
  GARAGE_TOKEN,
  WORKSHOP_ENDTIME,
  WORKSHOP_HOLIDAY,
  WORKSHOP_ID,
  WORKSHOP_STARTTIME,
} from "../../constants";
import axios from "axios";
import { isAutoServicesTenant } from "../../utils/tenantBranding";

const WorkshopAdminDrawerContent = () => {
  const location = useLocation();

  const { data: themeData } = useGetThemeDataQuery({});

  const isAnyChildActive = (paths) => {
    return paths.some((path) => location.pathname === path);
  };

  const themeColors = {
    blue: "#F25D21",
    purple: "#F25D21",
    pantone: "#F25D21",
    orange: "#F25D21",
  };

  const themeBackgroundColors = {
    blue: "#F8E9E3",
    purple: "#F8E9E3",
    pantone: "#F8E9E3",
    orange: "#F8E9E3",
  };

  const themeBorderColors = {
    blue: "#F25D21",
    purple: "#F25D21",
    pantone: "#F25D21",
    orange: "#F25D21",
  };

  const selectedColor = themeColors[themeData?.selected_theme] || "grey";
  const selectedBackgroundColor =
    themeBackgroundColors[themeData?.selected_theme] || "grey";
  const selectedBorderColor =
    themeBorderColors[themeData?.selected_theme] || "grey";

  const token = localStorage.getItem(GARAGE_TOKEN);
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  const logoutWorkshopAdmin = async () => {
    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/user/logout/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data) {
        // window.location.replace('/home');
        localStorage.removeItem(GARAGE_TOKEN);
        localStorage.removeItem(GARAGE_ROLE);
        localStorage.removeItem(GARAGE_ID);
        localStorage.removeItem(WORKSHOP_ID);
        localStorage.removeItem(WORKSHOP_HOLIDAY);
        localStorage.removeItem(WORKSHOP_STARTTIME);
        localStorage.removeItem(WORKSHOP_ENDTIME);

        window.location.replace("/auth/workshop-admin-login");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const handleLogout = () => {
    // localStorage.clear();
    logoutWorkshopAdmin();
    // window.location.replace("/auth/workshop-login");

    // if (isGarageAdminLoggedIn === "garage_tenant_admin") {
    // } else if (isGarageAdminLoggedIn === "garage_admin") {
    //   window.location.replace("/auth/workshop-admin-login");
    // }
  };

  const textStyle = { fontFamily: "Karbon", fontSize: "14px", color: "#666" };

  return (
    <List component="nav" style={{ paddingTop: "0px" }}>
      <div
        style={{
          height: "80px",
          width: "250px",
          overflow: "hidden",
          borderTopRightRadius: "50px",
          background: "#F25D213D",
          marginBottom: "20px",
        }}
      >
        <img
          src={
            autoServicesBranding
              ? "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg"
              : "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearelogo.png"
          }
          alt={autoServicesBranding ? "Auto Services logo" : "EUROREPAR logo"}
          style={{
            width: autoServicesBranding ? "200px" : "144px",
            height: "42px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            marginTop: "20px",
            marginLeft: autoServicesBranding ? "8%" : "15%",
          }}
        />
      </div>

      {/* Dashboard */}
      <ListItemButton
        disabled
        component={Link}
        to="/dashboard"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/dashboard"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/dashboard"]) ? `${selectedColor}` : "",
          border: isAnyChildActive(["/dashboard"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <img
            src="/Union.svg"
            alt="Dashboard Icon"
            style={{
              width: 24,
              height: 24,
              color: isAnyChildActive(["/dashboard"]) ? `${selectedColor}` : "",
            }}
          />
        </ListItemIcon>
        <ListItemText
          primary="Dashboard"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>

      {/* Service Master */}
      <ListItemButton
        component={Link}
        to="/vehicle/service-master"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/service-master"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/service-master"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/service-master"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/service-master"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-tools"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/service-master"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Service master"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>

      {/* Service Request */}
      <ListItemButton
        component={Link}
        to="/vehicle/service-request"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/service-request"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/service-request"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/service-request"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/service-request"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-wrench-adjustable"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/service-request"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Service request"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>

      {/* Appointment */}
      <ListItemButton
        component={Link}
        to="/vehicle/appointment"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedColor}`
            : "",
          border: isAnyChildActive(["/vehicle/appointment"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/appointment"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-wrench-adjustable"
            style={{
              fontSize: "24px",
              color: isAnyChildActive(["/vehicle/appointment"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Appointment"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>

      <ListItemButton
        component={Link}
        to="/vehicle/leads"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
          boxShadow: isAnyChildActive(["/vehicle/leads"])
            ? `${selectedColor}80 0px 2px 10px 2px`
            : "",
          color: isAnyChildActive(["/vehicle/leads"]) ? `${selectedColor}` : "",
          border: isAnyChildActive(["/vehicle/leads"])
            ? `1px solid ${selectedBorderColor}`
            : "",
          backgroundColor: isAnyChildActive(["/vehicle/leads"])
            ? `${selectedBackgroundColor}`
            : "transparent",
          borderRadius: "40px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i
            className="bi bi-menu-up"
            style={{
              fontSize: "18px",
              color: isAnyChildActive(["/vehicle/leads"])
                ? `${selectedColor}`
                : "",
            }}
          ></i>
        </ListItemIcon>
        <ListItemText
          primary="Leads"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>

      {/* Logout */}
      <ListItemButton
        onClick={handleLogout}
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          marginBottom: "10px",
        }}
      >
        <ListItemIcon style={{ minWidth: "35px" }}>
          <i className="bi bi-box-arrow-left" style={{ fontSize: "24px" }}></i>
        </ListItemIcon>
        <ListItemText
          primary="Logout"
          primaryTypographyProps={{
            style: textStyle,
          }}
        />
      </ListItemButton>
    </List>
  );
};

export default WorkshopAdminDrawerContent;
